import React from 'react'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc/es5'
import { BetterComponent } from '../better-component/better-component'
import { AppState } from '../../stores/app'
import { PushlyLoadingScreen } from '../../core/boot/pushly-loading-screen'

const FADE_OUT_MS = 800

interface IProps {
    loading?: boolean
    variant?: 'app' | 'module'
}

@observer
export class ModuleLoadingScreen extends BetterComponent<IProps, {}> {
    private appState: AppState
    private containerRef = React.createRef<HTMLDivElement>()

    public constructor(props: IProps) {
        super(props)
        this.appState = Container.get(AppState)
    }

    public componentWillUnmount() {
        // If we're still showing when unmounted (e.g., UserProvider swaps us out),
        // clone the DOM node and fade it out outside of React's tree.
        // Only applies to app variant — module variant fades via CSS transition.
        const el = this.containerRef.current
        if (!el || !el.classList.contains('active')) return
        if (el.classList.contains('variant-module')) return

        const clone = el.cloneNode(true) as HTMLElement
        document.body.appendChild(clone)

        // Force reflow so the browser registers the active opacity: 1 state
        // before we trigger the fade-out transition
        clone.getBoundingClientRect()
        clone.classList.remove('active')
        clone.classList.add('fading-out')

        setTimeout(() => {
            clone.remove()
        }, FADE_OUT_MS + 50)
    }

    public render() {
        const loading = this.props.loading !== undefined ? this.props.loading : this.appState.moduleLoading
        const variant = this.props.variant ?? 'module'

        return <PushlyLoadingScreen active={!!loading} variant={variant} containerRef={this.containerRef} />
    }
}
